import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cartSlice";
import configSlice from "./configSlice";

const store = configureStore({
  reducer: {
    cart: cartSlice,
    config: configSlice,
  }
})

export default store;